var map = {
	"./1.png": "c2de",
	"./2.png": "df38",
	"./3.png": "ccc4",
	"./4.png": "f16f",
	"./5.png": "36fc",
	"./6.png": "5364",
	"./7.png": "a410",
	"./desktop.png": "97c5",
	"./laptop.png": "cec4",
	"./mobile.png": "7b47",
	"./tablet.png": "5613"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8f17";